import { PlayerRef } from "@remotion/player";
import { Text } from "../../../../../../../library/text";
import { getIcon } from "../../../../../../../utils/get-icon";
import { useTimelineContext } from "../../../remotion-timeline/context/use-timeline-context";
import {
  ContentWrapper,
  TextWrapper,
  TimeIcon,
  Timestamp,
  TopWrapper,
} from "./styled";

interface CaptionProps {
  data: any;
  active: boolean;
  playerRef?: React.RefObject<PlayerRef>;
}

const Caption = ({ data, active, playerRef }: CaptionProps) => {
  const { fps, setSelectedItem } = useTimelineContext();

  const formatTimeFromFrames = (frames: number, fps: number): string => {
    const totalSeconds = Math.floor(frames / fps);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const startTime = formatTimeFromFrames(data.from, fps);
  const endTime = formatTimeFromFrames(data.from + data?.durationInFrames, fps);

  const handleCaptionClick = () => {
    if (playerRef?.current) {
      playerRef.current.seekTo(data.from);
      setSelectedItem(data.id);
    }
  };

  return (
    <ContentWrapper onClick={handleCaptionClick}>
      <TopWrapper>
        <Timestamp active={active}>{startTime}</Timestamp>
        <TimeIcon active={active}>{getIcon("arrow-right")}</TimeIcon>
        <Timestamp active={active}>{endTime}</Timestamp>
      </TopWrapper>
      <TextWrapper active={active}>
        <Text size="small" color="dark">
          {data.text}
        </Text>
      </TextWrapper>
    </ContentWrapper>
  );
};

export default Caption;
